import React from 'react';
import { LoaderComponent, AccordionComponent, Utils, AlertMessagesService, InputChips, RichTextEditorComponent } from "../../../shared";
import {
  OmniDropdownComponent,
  OmniIconComponent,
  OmniStyleComponent
} from '../../../shared/components/omni-components';
import '../../../styles/rfpCreate.css';
import { RfpService } from '../';
import { createRfpFields } from './rfpCreateFields';

const defaultState = {
  rfpData: {
    fields: createRfpFields
  },
  formData: { rfpName: '', rfpEmails: '', uploadedFiles: [] },
  isSaveDisabled: true,
  editDailog: false
}
export class RfpDialogComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
    this.onDataChange = this.onDataChange.bind(this);
    this.validators = {
      'Budget 1': Utils.isValidNumber,
      'Budget 2': Utils.isValidNumber,
      'Budget 3': Utils.isValidNumber,
    }
  }

  componentWillReceiveProps(props) {
    if(props.editRFPData){
      this.setState({editDailog:true});
      let editFormData = RfpService.prepareRfpEditFormData( props.editRFPData)
      this.setState({formData: editFormData});
    }else{
      this.setState({editDailog:false});
      this.setState({formData: defaultState.formData});
    }
    this.validateForm();
  }
  
  /**
   * remove the file from uploadedFiles in state on clicking the x icon on file name
   * @param {string} fileName filename to remove
   */
  removeUploadedFile(fileName) {
    const uploadedFiles = this.state.formData.uploadedFiles.filter(function (file) {
      return file.filename !== fileName;
    });
    this.setState({
      formData: {
        ...this.state.formData,
        uploadedFiles
      }
    },  () => {
      this.validateForm();
    });
  }

  /* The below code is adding an event listener to a file input element with the ID 'fileInput'. When a
  *file is selected using the file input, the code creates a FormData object and appends the selected
  *file(s) to it. It then checks if the selected file(s) have already been uploaded and if not, adds
  *them to an array of uploaded files in the component's state. If the file size is greater than 1MB,
  *an error message is displayed. */
  addFileUploadEventHandler = (event) => {
    this.setState({ spinnerCount: 1 });
    const filesArray = Array.from(event.target.files);
    const uploadedFiles = [...this.state.formData.uploadedFiles];
    const disAllowedMimetypes = ['text/plain','text/csv'];
    let totalFilesSize = 0;
    let totalFiles = 0;
    // Looping of already selected files to check total files & fileSize
    for(let i=0;i<uploadedFiles.length;i++){
      totalFilesSize+= uploadedFiles[i].size;
      totalFiles+= 1;
    }
    // Looping of newly selected files to check total files & fileSize
    for(let i=0;i<filesArray.length;i++){
      let fileSizeInBytes = filesArray[i].size;
      let fileSizeinKB = fileSizeInBytes / 1024;
      let filesSizeInMB = fileSizeinKB / 1024;
      filesArray[i].sizeInMB = filesSizeInMB;
      totalFilesSize+= filesArray[i].sizeInMB;
      totalFiles+= 1;
    }
    // Check for max of total 15MB file size limit, If exceeded, return & show the error
    if(totalFilesSize > 15){
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.addFileUploadEventHandler(event), title: 'Unable to add the file', bodyMsgArr: ['Total file size limit exceeded, Maximum of only 15MB files can be selected in total.']}]);
      this.setState({ spinnerCount: 0 });
      return;
    }
    // Check for max of total 5 file limit, If exceeded, return & show the error
    if(totalFiles > 5){
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.addFileUploadEventHandler(event), title: 'Unable to add the file', bodyMsgArr: ['Total file limit exceeded, Maximum of only 5 files can be selected in total.']}]);
      this.setState({ spinnerCount: 0 });
      return;
    }

    filesArray.forEach((file) => {
      const isFileUploaded = this.state.formData.uploadedFiles.find((obj) => {
        return obj.filename === file.name;
      });
      // if the file is already uploaded, do not upload same file again
      if (isFileUploaded) {
        return;
      }
      // Checking the disallowed file type (CSV or Text)
      if(disAllowedMimetypes.includes(file.type)){
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.addFileUploadEventHandler(event), title: 'Unable to add the file', bodyMsgArr: [`${file.name} is not a valid file type, Text & CSV files are not allowed.`]}]);
        this.setState({ spinnerCount: 0 });
        this.validateForm();
      // Checking the size of file
      } else if(file.sizeInMB > 5) {
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.addFileUploadEventHandler(event), title: 'Unable to add the file', bodyMsgArr: [`${file.name} file size is more than 5MB.`]}]);
        this.setState({ spinnerCount: 0 });
        this.validateForm();
      } else{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        let base64Data;
        reader.onloadend = async () => {
          base64Data = reader.result.split(',')[1];
          uploadedFiles.push({filename: file.name,file: base64Data, size: file.sizeInMB});
          this.setState({formData: {...this.state.formData,uploadedFiles}},() => {
              this.setState({ spinnerCount: 0 });
              this.validateForm();
            }
          );
        };
      }
    });
  };

  /**
   * on click browse button open file upload window
   */
  /**
   * The function opens a file upload dialog box when the corresponding element is clicked.
   */
  openFileUpload() {
    document.getElementById('fileInput').click();
  }

  /**
   * Description The code is defining a function called `validateForm` using arrow function syntax in
   * JavaScript. The function is using `this.setState` to update the state of a component.
   * Specifically, it is setting the `isSaveDisabled` property to `true` if any of the fields in
   * `this.state.rfpData.fields` are marked as mandatory and do not have a value in
   * `this.state.formData`. Otherwise, it sets `isSaveDisabled` to `false`. This function is likely
   * used to determine whether a form can be submitted or not based on whether all mandatory fields
   * have been filled out.
   */
  validateForm = () =>{
    this.setState({
      isSaveDisabled: this.state.rfpData.fields.some(
        (field) => field.mandatory && !this.state.formData[field.name]
      )
    });
  }

  /**
   * Callback function triggered when data changes.
   * This function handles changes in form data input fields and update the state accordingly
   * @param {string} type - The type of data being changed.
   * @param {Event} event - The event object associated with the change.
   */
  onDataChange = (type, event) => {
    let value = ''
    if(type !== 'rfpEmails'){
      value = Utils.getValue(event);
    }else{
      value = event.target.value
    }
    if (this.validators[type]) {
      // Validate the value using the corresponding validator function
      const isValidValue = this.validators[type](value);
      if (!isValidValue) {
        // Show an error message if the value is not valid
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.onDataChange(type, event), title: 'Unable to change the value', bodyMsgArr: []}]);
      }
    }
    // Update the form data with the new value
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [type]: value
        }
      },
      () => {
       this.validateForm();
      }
    );
  };

  /* The below code is defining a function called `createRfp` which sets the `spinnerCount` state to 1,
  *prepares a payload using `RfpService.prepareCreateRfpPayload` function and creates an RFP using
  *`RfpService.createRfp` function. If the RFP is created successfully, it shows a success toast
  *message and closes the dialog. If it fails to create the RFP, it shows an error toast message.
  *Finally, it sets the `spinnerCount` state to 0. */
  createRfp = () => {
    this.setState({ spinnerCount: 1 });
    const payload = RfpService.prepareCreateRfpPayload(
      this.state.formData,
      this.props.campaignObj.id,
      this.props.omniProfile,
      this.state.editDailog
    );
    // todo: uncomment below line after the backend is ready for file upload
    // payload['fileAttachments'] = this.state.formData.uploadedFiles;
      if(this.state.editDailog){
        let campaignId = encodeURIComponent(this.props.campaignObj.id);
        RfpService.updateRfp(this.props.editRFPData.id, payload, campaignId)
          .then((res) => {
            AlertMessagesService.showSuccessToastMessage('RFP Updated successfully');
            this.props.onDialogClose();
            this.props.onRfpCreate();
          })
          .catch(() => {
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.createRfp, title: 'Unable to update the RFP', bodyMsgArr: []}]);
          })
          .finally(() => {
            this.setState({ spinnerCount: 0 });
          });
      }else{
        let campaignId = encodeURIComponent(this.props.campaignObj.id);
        RfpService.createRfp(payload, campaignId)
          .then((res) => {
            AlertMessagesService.showSuccessToastMessage('RFP Created successfully');
            this.closeDialog();
            this.props.onRfpCreate();
          })
          .catch(() => {
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.createRfp, title: 'Unable to create the RFP', bodyMsgArr: []}]);
          })
          .finally(() => {
            this.setState({ spinnerCount: 0 });});
      }
  };

  /* The above code is a JavaScript function called `renderAccordion` that returns an array of
  *`AccordionComponent` elements. It first calls the `loadAccordions` function to load the data for
  *the accordions, and then maps over the `accordions` array to create an `AccordionComponent` for
  *each item in the array. The `key` prop for each `AccordionComponent` is set to a combination of
  *the accordion header and the index of the item in the array. */
  renderAccordion = () => {
    this.loadAccordions();
    return this.accordions.map((accordion, index) => (
      <AccordionComponent
        accordion={{...accordion, isOpen: true}}
        key={accordion.header + index}
      ></AccordionComponent>
    ));
  };

  /* The below code is defining an arrow function that initializes an empty array
  *called "accordions" and creates two objects called "budgetsObj" and
  *"strategyObj". These objects have a "header" property and an empty "content"
  *array. The purpose of this code is not clear without additional context. */
  loadAccordions = () => {
    this.accordions = [];
    const formData = { ...this.state.formData };
    let budgetsObj = {
      header: 'Budget and dates',
      content: []
    };
    let strategyObj = {
      header: 'Strategy and media',
      content: []
    };
    const getFields = (data = []) => {
      return data.map((field, index) => {
        if (!field.hidden) {
          if (field.field_type === 1) {
            // dropdown field
            const options = [];
            for (const fieldItem of field.fielditems) {
              options.push({
                label: fieldItem.name,
                value: fieldItem.code
              });
            }
            return (
              <div className='input-container' key={'field' + index}>
                <label htmlFor={field.name + index}>
                  {field.mandatory && <>* </>}
                  {field.name}
                </label>
                <OmniDropdownComponent
                  id={field.name + index}
                  options={options}
                  value={formData[field.name]?[formData[field.name]]:[]}
                  onDropdownChange={(e) => this.onDataChange(field.name, e)}
                  placeholder={'Select Option'}
                  hidefooter={true}
                  typeahead
                  searchindropdown
                ></OmniDropdownComponent>
              </div>
            );
          } else if (field.field_type === 2) {
            // input field
            return (
              <div className='input-container' key={'field' + index}>
                <label htmlFor={field.name + index}>
                  {field.mandatory && <>* </>}
                  {field.name}
                </label>
                <input
                  id={field.name + index}
                  value={formData[field.name] || ''}
                  className='input text'
                  onChange={(e) => this.onDataChange(field.name, e)}
                  maxLength={field.character_limit}
                  placeholder={field.placeholder}
                ></input>
              </div>
            );
          } else if (field.field_type === 5) {
            // date field
            return (
              <div className='input-container' key={'field' + index}>
                <label htmlFor={field.name + index}>
                  {field.mandatory && <>* </>}
                  {field.name}
                </label>
                <div className='date-field'>
                  <input
                    id={field.name + index}
                    data-date={
                      Utils.formatDateObject(formData[field.name])
                        ? Utils.formatDateObject(formData[field.name])
                        : 'Select date'
                    }
                    type='date'
                    className='input text'
                    onChange={(e) => this.onDataChange(field.name, e)}
                    placeholder={field.placeholder}
                  ></input>
                </div>
              </div>
            );
          } else if (field.field_type === 6) {
            // number field
            return (
              <div className='input-container' key={'field' + index}>
                <label htmlFor={field.name + index}>
                  {field.mandatory && <>* </>}
                  {field.name}
                </label>
                <input
                  id={field.name + index}
                  type='number'
                  onChange={(e) => this.onDataChange(field.name, e)}
                  placeholder={field.name}
                ></input>
              </div>
            );
          } else if (field.field_type === 7) {
            // radio field

            return (
              <div className='input-container' key={'field' + index}>
                <label htmlFor={field.name + index}>
                  {field.mandatory && <>* </>}
                  {field.name}
                </label>
                <div className='radio-section'>
                  {field.fieldItems.map((fieldItem, fieldItemIndex) => (
                    <React.Fragment
                      key={`${field.name}-fieldItem-${fieldItemIndex}`}
                    >
                      <input
                        type='radio'
                        id={fieldItem.id}
                        name={field.name}
                        onChange={(e) => this.onDataChange(field.name, e)}
                        value={fieldItem.value}
                        checked={
                          this.state.formData[field.name] === fieldItem.value
                        }
                      />
                      <label htmlFor={fieldItem.id}>{fieldItem.name}</label>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            );
          } else if (field.field_type === 9) {
            return (
              <div className='input-container span-two' key={'field' + index}>
                <label htmlFor={field.name + index}>
                  {field.mandatory && <>* </>}
                  {field.name}
                </label>
                <input
                  id={field.name + index}
                  type='text'
                  className='input text'
                  value={formData[field.name] || '' }
                  onChange={(e) => this.onDataChange(field.name, e)}
                  placeholder={field.name}
                ></input>
              </div>
            );
          } else if (field.field_type === 10) {
            return (
              <div className='browse-and-input-container' key={'field' + index}>
                <div className='input-container span-two'>
                  <div className='browse-container'>
                    <input type='file' id='fileInput' hidden multiple onChange={this.addFileUploadEventHandler} />
                    
                    <div className='browse-button'>
                      <span className='attachments'>Attachments</span>
                      <button className='button is-outlined is-medium' onClick={this.openFileUpload}>Browse</button>
                      <span className='file-size'>Max limit of 5MB/file and 15MB in total</span>
                    </div>

                    <div className='uploaded-files'>
                      {this.state.formData.uploadedFiles?.length > 0 ? this.state.formData.uploadedFiles.map((fileObj, index) => (
                        <div key={'uploaded-files' + index} className='uploaded-file'>
                          <p>{fileObj.filename}</p>
                          <OmniIconComponent
                            className='remove-icon'
                            icon-id='omni:interactive:remove'
                            onClick={this.removeUploadedFile.bind(this, fileObj.filename)}
                          ></OmniIconComponent>
                        </div>
                      )) : <span className="no-attachments">No attachments</span>}
                    </div>

                  </div>
                </div>
              </div>
            );
          } else if(field.field_type === 11){
            return ( 
            <div className='rich-text-container' key={'field' + index}>
              <label htmlFor={field.name + index}>
                {field.mandatory && <>* </>}
                {field.name}
              </label>
              <RichTextEditorComponent
                id={field.name + index} 
                content={formData[field.name] || ''}
                placeholder={field.placeholder}
                onChange={(e) => this.onDataChange(field.name, e)}
              ></RichTextEditorComponent>
            </div>
            );
          }
          else {
            return <></>;
          }
        } else {
          return <></>;
        }
      });
    };
    budgetsObj.content.push(
      <div className='rfp-create-section' key='rfpDetails-budget'>
        {getFields(this.state.rfpData?.fields?.filter((field) => field.budget))}
      </div>
    );
    strategyObj.content.push(
      <div className='rfp-create-section' key='rfpDetails-strrategy'>
        {getFields(
          this.state.rfpData?.fields?.filter((field) => !field.budget)
        )}
      </div>
    );
    this.accordions.push(budgetsObj);
    this.accordions.push(strategyObj);
  };

  /**
 * Closes the dialog and performs necessary cleanup.
 * @function
 * @name closeDialog
 * @returns {void}
 */
  closeDialog = () => {
    this.resetState()
    this.props.onDialogClose()
  }

  /**
 * Resets the state of the component to the default state.
 * @function
 * @name resetState
 * @returns {void}
 */
  resetState = () => {
    this.setState(defaultState)
  }

  /**
 * Validates an email input value using a regular expression pattern.
 * @param {string} inputValue - The email input value to be validated.
 * @returns {boolean} - True if the email input value is valid, false otherwise.
 */
  validateEmailInput = (inputValue) => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let isValid = pattern.test(inputValue);
    if (!isValid) {
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.validateEmailInput(inputValue), title: 'Unable to use invalid email', bodyMsgArr: []}]);
    }
    return isValid;
  };

  render() {
    return (
      <OmniStyleComponent>
        {this.props.isRfpModalOpen && (
          <div className='rfp-create-container modal is-active'>
            <div className='modal-content'>
              <LoaderComponent
                spinnerCount={this.state.spinnerCount}
                displayWholePage={true}
              />
              <article className='message'>
                <div>
                  <div className='message-header'>
                    <p className='object-title is-size-3'>{this.state.editDailog ? 'Edit ' : 'Create '} RFP</p>
                    <OmniIconComponent
                      className='is-size-4 closeIcon'
                      icon-id='omni:interactive:close'
                      onClick={this.props.onDialogClose}
                    ></OmniIconComponent>
                  </div>
                  <div className='rfp-create-section'>
                    <div className='input-container'>
                      <label htmlFor='rfp-name'>* RFP name</label>
                      <input
                        id='rfp-name'
                        onChange={(e) => this.onDataChange('rfpName', e)}
                        value={this.state.formData['rfpName']}
                        placeholder='Enter name'
                      />
                    </div>
                    <div className='input-container span-three'>
                      <label htmlFor='rfp-name'>* Contact email(s)</label>
                      <InputChips
                        placeholder={'Enter contact emails'}
                        containerClassName='input'
                        validateInput={this.validateEmailInput}
                        defaultValue={this.state.formData['rfpEmails']}
                        onChange={
                          (value) =>
                            this.onDataChange('rfpEmails', {
                              target: { value }
                            }) // Mimicing native event to reuse the common method
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className='message-body'>{this.renderAccordion()}</div>
                <div className='message-footer'>
                  <button
                    className='link-btn'
                    onClick={this.closeDialog}
                  >
                    Cancel
                  </button>
                  {
                    !this.state.editDailog && 
                    <button className='button is-outlined' disabled>
                      Save and Add another
                    </button>
                  }
                  <button className='button is-outlined' disabled>
                    Send to Media Ocean
                  </button> 
                  <button
                    className='button is-primary is-medium'
                    disabled={this.state.isSaveDisabled}
                    onClick={this.createRfp}
                  >
                    {this.state.editDailog ? 'Update' : 'Create'}
                  </button>
                </div>
              </article>
            </div>
          </div>
        )}
      </OmniStyleComponent>
    );
  }
}
